<!-- prettier ignore -->
<div class="opacity-70" [class.whitespace-pre-wrap]="lineBreakOption">{{ formattedSizeGuide }}</div>
